import { Address, isAddress } from 'viem'

export const resolveHlName = async (name: string): Promise<{ name: string; address: string }> => {
  if (isAddress(name)) {
    return { name, address: name }
  }

  let n = name
  if (!n.includes('hl')) {
    n += '.hl'
  }

  const res = await fetch(`https://api.hlnames.xyz/resolve/address/${n.toLowerCase()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-API-KEY': 'CPEPKMI-HUSUX6I-SE2DHEA-YYWFG5Y',
    },
  }).then((r) => r.json())

  return { name, address: res.address }
}

export const resolveHlPrimaryName = async (address: Address): Promise<string> => {
  const res = await fetch(`https://api.hlnames.xyz/resolve/primary_name/${address}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-API-KEY': 'CPEPKMI-HUSUX6I-SE2DHEA-YYWFG5Y',
    },
  }).then((r) => r.json())

  return res.primaryName
}
